import {Rank} from 'platform/components';
import {HStack, Show, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {CompareTrend} from '../../../../../components/CompareTrend/CompareTrend';

interface ComparedValueProps extends TestIdProps {
  value: number;
  difference: number | Nullish;
  rankValue?: number | Nullish;
  firstScrape?: number | Nullish;
  formatter?: (value: number) => string | null;
  firstScrapeFormatter?: (value: number) => string | null;
  isReverseColor?: boolean;
  isAlignEnd?: boolean;
}

export function ComparedValue(props: ComparedValueProps) {
  return (
    <VStack align={props.isAlignEnd ? 'flex-end' : undefined} spacing={1}>
      <Show when={isNotNil(props.firstScrape) && props.firstScrape !== props.value}>
        <Text size="xxSmall" color="secondary" strikethrough noWrap>
          {props.firstScrapeFormatter?.(props.firstScrape!)}
        </Text>
      </Show>
      <HStack spacing={1}>
        <Text size="small" alternative noWrap>
          {props.formatter?.(props.value) ?? `${props.value}`}
        </Text>
        {isNotNil(props.rankValue) && (
          <Rank percentage={props.rankValue} data-testid={suffixTestId('comparedValue', props)} />
        )}
      </HStack>
      <Show when={isNotNil(props.difference)}>
        <CompareTrend
          value={props.difference!}
          formatter={props.formatter}
          reverse={props.isReverseColor}
        />
      </Show>
    </VStack>
  );
}
